module.exports = "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-md-2\">\n      <div class=\"sidemenu\">\n        <ul class=\"billmenu\">\n          <li><a [routerLink]=\"['/home/agreements']\"> Agreements </a></li>\n          <li><a [routerLink]=\"['agreements-approval']\"> Agreements Approval </a></li>\n        </ul>\n      </div>\n    </div>\n    <div class=\"col-md-10\">\n      <router-outlet></router-outlet>\n    </div>\n  </div>\n</div> "


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/agreements-app/agreements-app.component.html
// module id = ./src/app/recovery/agreements-app/agreements-app.component.html
// module chunks = main